import { useDispatch } from "react-redux"
import { useMutation } from "@tanstack/react-query"
import { Creators as ApiWrapperCreators } from "model/apiWrapper"
import { SigmaWorkbookInput } from "../types"

export function useUpdateSigmaSolution(
  accountAlias: string,
  solutionId: string,
  onSuccess: () => void,
  onError: (error: Error) => void,
) {
  const dispatch = useDispatch()

  return useMutation<unknown, Error, SigmaWorkbookInput>({
    mutationFn: (payload) => new Promise((resolve, reject) => {
      dispatch(ApiWrapperCreators.put(`/api/${accountAlias}/solutions/sigma/${solutionId}`, payload, resolve, reject))
    }),
    onSuccess,
    onError,
  })
}
